// extracted by mini-css-extract-plugin
export default {"container":"JobList_container__woW6L","left":"JobList_left__vDY0n","title":"JobList_title__z2MO3","subtitle":"JobList_subtitle__Rzkdh"};